import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Em build/execução, apenas logamos em console. O app ainda carrega, mas login vai falhar.
  // Em produção, garanta que as variáveis estejam configuradas na Vercel.
  // eslint-disable-next-line no-console
  console.warn('Supabase URL ou Anon Key não configurados. Login não funcionará.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;
